import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Campaign } from '../../views/campaign/new-campaign/campaign';
import 'rxjs/Rx';


@Injectable()
export class CampaignService {

  customers: any[];


  constructor(private h: HttpClientService) {

  }

  /**
   * Ad apertura Nuova Campagna, restituisce la lista dei possibili obiettivi
   */
  getCreateCampaignFormData() {
    return this.h.get('/koncentro-campaign/campaign/getBusinessGoalList').map(res => {
      return this.customers = res;
    });
  }

  /**
   * Restituisce la lista dei Canali
   */
  getChannels() {
    return this.h.get('/koncentro-campaign/campaign/channels');
  }

  /**
   * Restituisce la lista delle priorità di default e attiva/disattiva i flag nello Step 2
   * @param businessGoalCode
   */
  getChannelPriorities(businessGoalCode) {
    return this.h.get('/koncentro-campaign/campaign/prefillParameters?businessGoalCode=' + businessGoalCode);
  }

  /**
   * Restituisce l'elenco dei nomi, con i rispettivi id, dei tipi di sconti applicabili alla campagna
   */
  getMeccaniche() {
    return this.h.get('/koncentro-campaign/campaign/meccaniche');
  }

  /**
   * Restituisce i valori di default degli sconti
   * @param businessGoalCode
   */
  getPrefillMeccaniche(businessGoalCode){
    return this.h.get('/koncentro-campaign/campaign/prefillMeccaniche?businessGoalCode=' + businessGoalCode);
  }

  /**
   * Restituisce i dati della Campagna con nome campaign_name
   * @param name
   */
  getCampaign(name) {
    return this.h.post('/koncentro-campaign/campaign/getCampaign', { campaign_name: name });
  }

  /**
   * Crea la Campagna al salvataggio dopo lo Step 3
   * @param campaignData
   */
  campaignCreation(campaignData) {
    return this.h.post('/koncentro-campaign/campaign/createCampaign', campaignData);
  }

  /**
   * Restituisce la lista dei negozi associabili alla Campagna, filtrandoli a seconda dei parametri inviati.
   * Se nel parametro "codici" di "filters" sono presenti store_code, restituisce i negozi già associati alla Campagna
   * @param filters
   */
  getStoresFromFilters(filters: object) {
    return this.h.post('/koncentro-common/store/stores_from_campaigns?limit=999999', filters);
  }

  /**
   * Restituisce la lista dei filtri Area Geografica per i Negozi
   */
  getAreaGeo() {
    return this.h.get('/koncentro-common/store/getAreaGeo');
  }

  /**
   * Restituisce la lista dei filtri Insegne per i Negozi
   */
  getInsegna() {
    return this.h.get('/koncentro-common/store/getInsegna');
  }

  /**
   * Restituisce la lista dei filtri Gruppi per i Negozi
   */
  listGroups() {
    return this.h.get('/koncentro-common/store-group');
  }

  /**
   * Restituisce la lista dei Gruppi di Negozi
   */
  listGroupsWithStores() {
    return this.h.get('/koncentro-common/store-group/stores');
  }

  /**
   * Restituisce la lista dei negozi di un Gruppo
   * @param groupdId
   */
  listStoresInGroup(groupdId) {
    return this.h.get(`/koncentro-common/store-group/${groupdId}/store`);
  }

  /**
   * Crea un nuovo Gruppo di Negozi
   * @param groupData
   */
  createGroup(groupData) {
    return this.h.post('/koncentro-common/store-group', groupData);
  }

  /**
   * Aggiunge gli stores selezionati al gruppo con groupid
   * @param groupId
   * @param stores
   */
  setStoresInGroup(groupId, stores) {
    return this.h.post(`/koncentro-common/store-group/${groupId}/store`, stores);
  }

  /**
   * Restituisce la lista dei Clienti Target
   */
  getSegments() {
    return this.h.get('/koncentro-campaign/campaign/getSegment');
  }

  /**
   * Restituisce la lista dei Clienti Target suggeriti per la Campagna
   * @param targetId
   */
  getSegmentSuggestions(campaignName: string) {
    return this.h.post('/koncentro-campaign/campaign/getSegmentSuggestions', { campaign_name: campaignName });
  }

  /**
   * Associa i Target Clienti alla Campagna
   * @param campaign_name
   * @param segments
   */
  setCampaignSegments(campaign_name: string, segments: Array<string>) {
   return this.h.post('/koncentro-campaign/campaign/updateCampaignWithSegment', {
     campaign_name: campaign_name,
     targeted_segments: segments.join('-')
   });
  }

  /**
   * Aggiorna la lista dei Negozi associati alla Campagna
   * @param campaign_name
   * @param stores
   */
  setCampaignStores(campaign_name: string, stores: Array<string>) {
    return this.h.post('/koncentro-campaign/campaign/updateCampaignWithStore', {
      campaign_name: campaign_name,
      stores: stores
    });
  }

  /**
   * Restituisce la lista dei Tipi di Coupon
   */
  getCouponTypes() {
    return this.h.get('/koncentro-campaign/campaign/getCouponType');
  }

  /**
   * Restituisce la lista dei Tipi di Coupon suggeriti
   * @param targetId
   */
  getCouponTypeSuggestions(targetId: number) {
    return this.h.post('/koncentro-campaign/campaign/getCouponTypeSuggestions', { business_goal_code: targetId });
  }

  /**
   * Restituisce i tipi di coupon da attivare per la campagna con nome campaignName
   * @param campaignName
   */
  getActiveCoupons(campaignName) {
    return this.h.get(`/koncentro-campaign/campaign/getActiveCoupons?campaignName=${campaignName}`)
  }

  /**
   * Restituisce i valori min e max per i parametri del coupon Trade Driver
   * @param businessGoalCode
   */
  getTradeDriverParamsLimitsSuggestion(businessGoalCode) {
    return this.h.post(`/koncentro-campaign/campaign/getCouponSettingsSuggestions_1`, {business_goal_code: businessGoalCode})
  }

  /**
   * Restituisce i valori suggeriti o salvati dei parametri del coupon Trade driver
   * @param campaignName
   */
  getTradeDriverParamsValueSuggestion(campaignName) {
    return this.h.post('koncentro-campaign/campaign/getCouponWebSettingsSuggestions_1', {campaign_name: campaignName})
  }

    /**
   * Restituisce i valori min e max per i parametri del coupon Categoria
   * @param businessGoalCode
   */
  getCategoryCouponParamsLimitsSuggestion(businessGoalCode) {
    return this.h.post(`/koncentro-campaign/campaign/getCouponSettingsSuggestions_2`, {business_goal_code: businessGoalCode})
  }

  /**
   * Restituisce i valori suggeriti o salvati dei parametri del coupon Categoria
   * @param campaignName
   */
  getCategoryCouponParamsValueSuggestion(campaignName) {
    return this.h.post('koncentro-campaign/campaign/getCouponWebSettingsSuggestions_2', {campaign_name: campaignName})
  }

  /**
   * Viene richiamata all'aggiunta di un nuovo coupon Prodotto alla lista
   * @param campaignName
   * @param typeCode
   * @param businessGoalCode
   */
  addProductCoupon(campaignName, typeCode, businessGoalCode) {
    return this.h.post('/koncentro-campaign/campaign/addProductCoupon', {
      campaign_name: campaignName,
      type_code: typeCode,
      business_goal_code: businessGoalCode
    })
  }

  /**
   * Restituisce i valori min e max per la percentuale di sconto dei coupon Prodotto
   * @param businessGoalCode
   * @param typeCode
   */
  getProductCouponOfferLimitsSuggestion(businessGoalCode, typeCode) {
    return this.h.get(`koncentro-campaign/campaign/getProductCouponSettingsSuggestions?businessGoalCode=${businessGoalCode}&typeCode=${typeCode}`)
  }

  /**
   * Restituisce le offerte ed i prodotti del coupon Prodotto
   * @param campaignName
   * @param typeCode
   */
  getProductCouponOfferAndProductsSuggestion(campaignName, typeCode) {
    return this.h.get(`koncentro-campaign/campaign/getProductCouponWebSettingsSuggestions?campaignName=${campaignName}&typeCode=${typeCode}`)
  }

  /**
   * Viene richiamata alla disattivazione di un tipo di Coupon
   * @param typeCode
   * @param campaignName
   */
  disattivaCoupon(typeCode, campaignName) {
    return this.h.post('/koncentro-campaign/campaign/disattivaCoupon?typeCode=' + typeCode + '&campaignName=' + campaignName, {})
  }

  /**
   * Restituisce la lista delle Categorie di Coupon
   * @param campaignName
   */
  getCouponCategoryTypes(campaignName: string) {
    return this.h.get('/koncentro-campaign/campaign/getCouponCategoryType/' + campaignName);
  }

  /**
   * Restituisce le Categorie suggerite per i Coupon
   * @param campaignName
   */
  getCouponCategoryTypeSuggestions(campaignName: string) {
    return this.h.post('/koncentro-campaign/campaign/getCouponCategoryTypeSuggestions', { campaign_name: campaignName });
  }

  /**
   * Restituisce la lista dei Prodotti di una determinata categoria
   * @param params
   */
  getCouponProduct(params) {
    return this.h.post('/koncentro-campaign/campaign/getCouponProduct', params);
  }

  /**
   * Setta lo stato della campagna a Step 5
   */
  prepareIstanzaWork(campaignName: string) {
    return this.h.post('koncentro-campaign/campaign/prepareIstanzaWork', {campaign_name: campaignName});
  }

  /**
   * Invia i valori inseriti nei parametri dei Coupon
   * @param params
   * @param type_code
   */
  loadCouponPreview(params, type_code) {
    return type_code == 3 || type_code == 4 ? this.h.post('/koncentro-campaign/campaign/caricaInstanzaWorkProdotti', params) : this.h.post('/koncentro-campaign/campaign/caricaInstanzaWork', params);
  }

  /**
   * Richiamata successivamente alla loadCouponPreview, restituisce la Preview della lista dei Coupon
   * @param campaign_name
   * @param type_code
   * @param targetId
   */
  getCouponPreview(campaign_name: string, type_code: number) {
    switch(type_code) {
      case 1:
        return this.h.post('/koncentro-campaign/campaign/recapTradeDriver', { campaign_name: campaign_name, type_code: type_code });
      case 2:
        return this.h.post('/koncentro-campaign/campaign/recapCategoryCoupon', { campaign_name: campaign_name, type_code: type_code });
      default:
        return this.h.post('/koncentro-campaign/campaign/recapProductCoupon', { campaign_name: campaign_name, type_code: type_code });
    }
  }

  /**
   * Richiamata successivamente alla getCouponPreview, Restituisce la lista dei Coupon generati
   * @param campaignName
   * @param typeCode
   */
  getCouponList(campaignName, typeCode) {
    return typeCode == 3 || typeCode == 4 ? this.h.get('/koncentro-campaign/campaign/getCouponListProducts?campaignName=' + campaignName + '&typeCode=' + typeCode) : this.h.get('/koncentro-campaign/campaign/getCouponList?campaignName=' + campaignName + '&typeCode=' + typeCode);
  }

  /**
   * Restituisce "OK" se il Targeting dei Coupon è disponibile, viceversa restituisce "KO"
   */
  getAvailableTargeting(campaignName: string) {
    return this.h.get(`/koncentro-campaign/campaign/sumodule/getAvailableTargeting?codice_wave=${campaignName}`);
  }

  /**
   * Restituisce la lista dei possibili Target di Clienti dei Coupon di una Campagna
   */
  getSegmentsOptions() {
    return this.h.get('/koncentro-campaign/campaign/getSegmentOptions');
  }

  /**
   * Restituisce i tipi di sconto applicabili ai Coupon della Campagna
   * @param campaignName
   * @param typeCode
   */
  getTipoSconto(campaignName, typeCode) {
    return this.h.get('/koncentro-campaign/campaign/getTipoSconto?campaignName=' + campaignName + '&typeCode=' + typeCode);
  }

  /**
   * Restituisce la lista delle Categorie applicabili ai Coupon della Campagna
   * @param typeCode
   */
  getCategoriaOfferta(typeCode) {
    return this.h.get('/koncentro-campaign/campaign/getCategoriaOfferta?typeCode=' + typeCode);
  }

  /**
   * Aggiorna il Coupon con i nuovi dati inseriti
   * @param params
   */
  updateCoupon(params) {
    return this.h.put('/koncentro-campaign/campaign/updateCoupon', params);
  }

  /**
   * Elimina il Coupon
   * @param id
   */
  deleteCoupon(id) {
    return this.h.delete('/koncentro-campaign/campaign/coupon/' + id);
  }

  /**
   * Aggiunge nuovi Coupon alla lista
   * @param campaignName
   * @param typeCode
   * @param params
   */
  addCoupon(campaignName, typeCode, params) {
    return this.h.post('/koncentro-campaign/campaign/addCoupon?campaignName=' + campaignName + '&typeCode=' + typeCode, params);
  }

  /**
   * Esegue il Targeting dei Coupon
   * @param codiceWave
   */
  startTargeting(codiceWave) {
    return this.h.post('koncentro-campaign/campaign/sumodule/startTargeting?codice_wave=' + codiceWave, {});
  }

  /**
   * Restituisce la lista delle Campagne esistenti
   * @param params
   */
  campaignList(params) {
    return this.h.post('/koncentro-campaign/campaign/search', params);
  }

  /**
   * Salva lo stato attuale dei dati dei coupon per recuperarli al momento della riapertura della campagna
   * @param campaignName
   * @param data
   */
  saveCampaign(campaignName, data) {
    return this.h.post(`/koncentro-campaign/campaign/saveCampaign?campaignName=${campaignName}`, data);
  }

  /**
   * setta lo stato della campagna a Step 4
   * @param campaignName
   */
  setCampaignCreated(campaignName) {
    return this.h.post('/koncentro-campaign/campaign/setCampaignCreated', {campaign_name: campaignName});
  }

  /**
   * Elimina la campagna
   * @param campaignName
   */
  deleteCampaign(campaignName: string) {
    return this.h.delete(`/koncentro-campaign/campaign/?campaignName=${campaignName}`);
  }

  /********************* Summary di Campagna in stato Elaborata ***********************/

  getCostPerTypeData(campaignName: string) {
    return this.h.get(`/koncentro-campaign/campaign/cost-per-type/?campaignName=${campaignName}`);
  }

  getCampaignSummaryData(campaignName: string) {
    return this.h.get(`/koncentro-campaign/campaign/campaign-summary/?campaignName=${campaignName}`);
  }

  getCampaignCostPerChannelData(campaignName: string) {
    return this.h.get(`/koncentro-campaign/campaign/campaign-cost-per-channel?campaignName=${campaignName}`);
  }


  /********************* Summary di Campagna in stato Live ***********************/

  getCampaignEmissionRedemptionData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-emission-redemption', { campaign_name: campaign_name });
  }

  getLiveEvaluationBudgetPerTypeData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-budget-per-type', { campaign_name: campaign_name });
  }

  getCampaignProgressData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-progress', { campaign_name: campaign_name });
  }


  /********************* Summary di Campagna in stato Valutata ***********************/

  getCampaignRedemptionClusterData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-redemption-cluster', { campaign_name: campaign_name });
  }

  getCampaignIncrementalSpentData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-incremental-spent', { campaign_name: campaign_name });
  }

  getBudgetPerTypeFinalEvalutionData(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/campaign-budget-per-type-final-evalution', { campaign_name: campaign_name });
  }


  /* *************************** UTILIZZATE, MA NON CONOSCO FUNZIONE PRECISA ***************************** */

  // Utilizzate in Lista Campagne
  /**
   *
   * @params year
   */
  getCampaignYearBudget(year) {
    return this.h.get('/koncentro-campaign/campaign/getCampaignYearBudget/' + year);
  }

  /**
   *
   * @params year
   */
  getScheduledYearBudget(year) {
    return this.h.get('/koncentro-campaign/campaign/getBudgetAnno/' + year);
  }

  /* ********************* UTILIZZATE MA FORSE INUTILI ******************** */

  // Richiamata in apertura di step 2, ma restituisce dati che sembrano inutilizzati
  getCreateCampaignDefaultFormData(id) {
    return this.h.get('/koncentro-campaign/campaign/getCampaignPrefileData/' + id);
  }

  // Richiamata in NextStep() nello step 5, ma il pulsante non è piú presente. Forse da associare a Esegui Targeting?
  confirmCampaign(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/approveCampaign', { campaign_name: campaign_name });
  }

  // Richiamate nel componente SummaryComponent di Campaign, il quale non sembra essere piú utilizzato
  getCampaignSummary(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/getSummary1', { campaign_name: campaign_name });
  }

  getBudgetOverview(campaign_name: string) {
    return this.h.post('/koncentro-campaign/campaign/getBudgetOverview', { campaign_name: campaign_name });
  }



  /* ******************** INUTILIZZATE ********************** */

  getStates() {
    return this.h.get('koncentro-common/state/states');
  }

  truncateCouponPreview() {
    return this.h.get('/koncentro-campaign/campaign/truncateIstanzaWork');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/campaign/campaign.service.ts